/*子系统功能相关路由*/

/*运行管理系统*/
import yxgl_system_modules from './yxgl/yxgl_system_page';/*运行管理系统*/
import nzywsjgl_system_modules from './nzywsjgl/nzywsjgl_system_page';/*农资业务数据管理系统*/
import yxzc_system_modules from './yxzcxt/yxzc_system_page';/*运行支撑系统*/
import warehousing_system_modules from './warehousing/warehousing_system_page';/*仓储物流管理系统*/
import policy_system_modules from './policyNews/policy_system_page';/*仓储物流管理系统*/
import xtbg_system_modules from './xtbgxt/xtbg_system_page';/*协同办公系统*/
import agro_service_page from './agroService/agro_service_page';/*协同办公系统*/
import zjzd_system_modules from './zjzd/zjzd_system_page';/*专家指导系统*/
import cpsy_system_page from './cpsy/cpsy_system_page';/*产品溯源系统*/
import nhfwdlm_system_page from './nhfwdlm/nhfwdlm_system_page'
export default [
  ...yxgl_system_modules,/*运行管理系统*/
  ...nzywsjgl_system_modules,/*农资业务数据管理系统*/
  ...yxzc_system_modules,/*运行支撑系统*/
  ...warehousing_system_modules,/*仓储物流管理系统*/
  ...policy_system_modules,/*资讯发布系统*/
  ...xtbg_system_modules,/*协同办公系统*/
  ...agro_service_page, // 为农服务
  ...zjzd_system_modules, // 专家指导
  ...cpsy_system_page, // 产品溯源
  ...nhfwdlm_system_page //农化服务大联盟
]



// WEBPACK FOOTER //
// ./src/router/modules/sub_system_page.js